import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash';
import {
  CustomAlertingSettings,
  RMMAlertTypes,
  RmmAlertingGeneralAlerts,
  RmmAlertingWindowsAlerts
} from 'mbs-ui-shared@models/rmm-custom-notification-model';
import { LoadRmmCustomNotificationWizardService } from '../../utility/load-rmm-custom-notification-wizard.service';

@UntilDestroy()
@Component({
  selector: 'mbs-action-template',
  templateUrl: './action-template.component.html'
})
export class ActionTemplate {
  public noEnabledAlerts = false;
  public alerts: RMMAlertTypes[] = RmmAlertingGeneralAlerts.concat(RmmAlertingWindowsAlerts);

  constructor(private loadRmmCustomNotificationWizardService: LoadRmmCustomNotificationWizardService) {
    this.loadRmmCustomNotificationWizardService.notificationsToSave.pipe(untilDestroyed(this)).subscribe((value) => {
      this.noEnabledAlerts = !this.alerts.some((key) => value && key in value && value[key].enabled);
    });
  }

  dataChange(data: CustomAlertingSettings) {
    this.loadRmmCustomNotificationWizardService.notificationsToSave.next(cloneDeep(data));
  }
}
